import { ServiceRequestType } from '#generated-types';

export const serviceRequestTypes = [
  { id: ServiceRequestType.FeatureRequest, name: 'Feature request' },
  { id: ServiceRequestType.Problem, name: 'Problem' },
  { id: ServiceRequestType.Question, name: 'Question' },
];
